import React from 'react'
import {useLocation,Outlet} from "react-router-dom"
import OrderSuccessBanner from '../../Orders/OrderSuccessBanner';

const Layout = () => {
const location=useLocation();
const {Message,OrderedItems,TotalAmount}=location.state || {}
console.log("banner details",Message,OrderedItems)
  return (
     <div className="min-h-screen">
      {Message && <OrderSuccessBanner Message={Message} OrderedItems={OrderedItems}TotalAmount={TotalAmount} />}
      <Outlet />
    </div>
  )
}

export default Layout
